import { LitElement, html, css } from 'lit';

class ToujouCardFigureToggle extends LitElement {
  static get is() {
    return 'toujou-card-figure-toggle';
  }

  static get properties() {
    return {
      showMap: {
        type: Boolean,
        reflect: true,
        attribute: 'show-map',
      },
    };
  }

  static get styles() {
    return css`
      :host {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      }
    `;
  }

  constructor() {
    super();
    this.showMap = false;
  }

  connectedCallback() {
    super.connectedCallback();
  }

  render() {
    return html`
      <slot></slot>
      <slot name="figure-toggle-button" @click="${e => this._handleToggleButtonClick(e)}"></slot>
    `;
  }

  /**
   * @param {MouseEvent} event
   *
   * @return void
   */
  _handleToggleButtonClick(event) {
    event.stopPropagation();
    event.preventDefault();

    this.showMap = !this.showMap;
  }
}

customElements.define(ToujouCardFigureToggle.is, ToujouCardFigureToggle);
